import { render } from "./tree.vue?vue&type=template&id=ec82c6ae&scoped=true"
import script from "./tree.vue?vue&type=script&lang=js"
export * from "./tree.vue?vue&type=script&lang=js"

import "./tree.vue?vue&type=style&index=0&id=ec82c6ae&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ec82c6ae"

export default script